import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ChangePassword from "../components/ChangePassword/ChangePassword";
import MobileTab from "../components/common/MobileTab";
import SideNavBar from "../components/common/SideNavBar";
import { Footer, NewsLetter } from "../components/layout";
import Header from "../components/layout/Header";
import ProfileForm from "../components/Profile/ProfileForm";
import { AuthChangePassword } from "../redux/slices/changePassword/changePasswordSlice";
import { fetchCities } from "../redux/slices/city/cityReducer";
import { fetchUser, updateUser } from "../redux/slices/user/userSlice";
import { dispatch } from "../redux/store";
import { setFavLoggedIn } from "../redux/slices/favorite/favoriteSlice";

function Profile() {
  const [editProfile, setEditProfile] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);

  const { auth } = useSelector((state: any) => state.auth);
  const { user } = useSelector((state: any) => state.user);

  // console.log(user);

  useEffect(() => {
    dispatch(fetchCities());
    if (auth) dispatch(fetchUser(auth.userId));
  }, []);

  const handleChangePassword = () => {
    setShowChangePassword(true);
    setEditProfile(false);
  };

  const handleCancelChangePassword = () => {
    setShowChangePassword(false);
    setEditProfile(false);
  };

  return (
    <>
      <div className="hidden lg:block">
        <Header />
      </div>
      <div className="block lg:hidden">
        <MobileTab title="My Profile" />
      </div>
      <div className="w-full flex justify-center lg:px-12 lg:py-12">
        <div className="flex lg:flex-row flex-col w-full max-w-[1440px] gap-10">
          <div className="hidden lg:block">
            <SideNavBar />
          </div>
          {user && (
            <div className="flex-grow h-full px-3 lg:py-4 bg-white rounded-md">
              <div className="font-semibold hidden lg:block">My Profile</div>
              {editProfile ? (
                <ProfileForm
                  setModal={setEditProfile}
                  item={user}
                  onSubmit={(values) =>
                    dispatch(updateUser(auth.userId, values))
                  }
                />
              ) : showChangePassword ? (
                <ChangePassword
                  toggleForm={handleCancelChangePassword}
                  onSubmit={(values, { setSubmitting }) => {
                    dispatch(AuthChangePassword(values)).then((res) => {
                      if (res.success) {
                        setSubmitting(false);
                        setShowChangePassword(false);
                      }
                    });
                    setSubmitting(false);
                  }}
                />
              ) : (
                <div className="w-full gap-8 pt-4 grid lg:grid-cols-3 grid-cols-1 px-3">
                  <div className="w-full flex flex-col gap-3 lg:h-32">
                    <div className="w-full text-sm font-semibold">Fullname</div>
                    <div className="w-full text-sm">
                      {user?.firstName} {user?.lastName}
                    </div>
                  </div>
                  <div className="w-full flex flex-col gap-3 lg:h-32">
                    <div className="w-full text-sm font-semibold flex gap-2">
                      <div className=" text-sm font-semibold">
                        E-mail Address
                      </div>
                    </div>
                    <div className="w-full text-sm">{user?.userName}</div>
                  </div>
                  <div className="w-full flex flex-col gap-3 lg:h-32">
                    <div className="w-full text-sm font-semibold flex gap-2">
                      <div className=" text-sm font-semibold">
                        Mobile Number
                      </div>
                    </div>
                    <div className="w-full text-sm">{user.phoneNo}</div>
                  </div>
                  <div className="w-full flex flex-col gap-3 lg:h-32">
                    <div className="w-full text-sm font-semibold">
                      Date of Birth
                    </div>
                    <div className="w-full text-sm">
                      {moment(user?.dateOfBirth).format("LL")}
                    </div>
                  </div>
                  <div className="w-full flex flex-col gap-3 lg:h-32">
                    <div className="w-full text-sm font-semibold">City</div>
                    <div className="w-full text-sm">{user?.city}</div>
                  </div>
                  <div className="w-full flex flex-col gap-3 lg:h-32">
                    <div className="w-full text-sm font-semibold">Gender</div>
                    <div className="w-full text-sm">{user?.gender}</div>
                  </div>
                </div>
              )}
              {!editProfile && !showChangePassword && (
                <div className="w-full flex flex-col items-center justify-center lg:justify-center lg:items-center lg:flex-row gap-4 pt-5">
                  <div
                    onClick={() => setEditProfile(true)}
                    className="w-full cursor-pointer lg:w-40 h-12 text-white font-semibold content-center text-center bg-[#05A30D] hover:opacity-70 rounded-[43px] px-[32px] py-[14px] gap-[12px]"
                  >
                    Edit Profile
                  </div>
                  <div
                    onClick={handleChangePassword}
                    className="w-full cursor-pointer lg:w-40 h-12 text-white font-semibold flex justify-center items-center bg-[#D33D3D] hover:opacity-70  rounded-[43px] px-[32px] py-[14px] whitespace-nowrap"
                  >
                    Change Password
                  </div>
                </div>
              )}
            </div>
          )}

          {!auth && (
            <div className="flex-grow h-full text-gray-400 flex flex-col items-center justify-center px-3 lg:py-4 bg-white rounded-md">
              <div className="text-lg font-semibold">
                Please Log in to view your profile
              </div>
              <div
                onClick={() => dispatch(setFavLoggedIn(true))}
                className="text-md transition-all hover:scale-105 text-white font-semibold bg-[#05A30D] px-4 py-1 rounded-full cursor-pointer hover:bg-[#05A30D]"
              >
                Login
              </div>
            </div>
          )}
        </div>
      </div>
      <NewsLetter />
      <Footer />
    </>
  );
}

export default Profile;
